import { render, staticRenderFns } from "./OpenShiftCard.vue?vue&type=template&id=5be160db&"
import script from "./OpenShiftCard.vue?vue&type=script&lang=js&"
export * from "./OpenShiftCard.vue?vue&type=script&lang=js&"
import style0 from "./OpenShiftCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemGroup } from 'vuetify/lib/components/VList';
installComponents(component, {VCard,VChip,VList,VListItem,VListItemContent,VListItemGroup})


/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5be160db')) {
      api.createRecord('5be160db', component.options)
    } else {
      api.reload('5be160db', component.options)
    }
    module.hot.accept("./OpenShiftCard.vue?vue&type=template&id=5be160db&", function () {
      api.rerender('5be160db', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/scheduling/cards/OpenShiftCard.vue"
export default component.exports